module.exports = __webpack_public_path__ + "static/media/teak_without_koto.cd5915bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interiorColors/teak_without_koto.jpg
// module id = 29
// module chunks = 0